/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    currentSections: string[];
    changeset: EmberChangeset;
    translationPrefix: string;
  };
}

import templateOnly, { type TOC } from "@ember/component/template-only";
import type { EmberChangeset } from "ember-changeset";
const MiciBaseEditionFormSummaryComponent: TOC<Signature> = templateOnly();
export default MiciBaseEditionFormSummaryComponent;
